import { render, staticRenderFns } from "./ControllerBottom.vue?vue&type=template&id=4f300aa1&"
import script from "./ControllerBottom.vue?vue&type=script&lang=js&"
export * from "./ControllerBottom.vue?vue&type=script&lang=js&"
import style0 from "./ControllerBottom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports